(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kalme-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindAbout(root) {
      if (!root || root.hasAttribute('data-about-ready')) return;
      root.setAttribute('data-about-ready', '');

      var links = root.querySelectorAll('[data-about-link]');
      var panels = root.querySelectorAll('[data-about-panel]');
      if (!links.length || !panels.length) return;

      var squeeze = window.matchMedia('(min-width: 990px)');

      function scrollRoot() {
        if (squeeze.matches) {
          return document.querySelector('.page-wrapper') || null;
        }
        return null;
      }

      function setActive(id) {
        Array.prototype.forEach.call(links, function (link) {
          var on = link.getAttribute('data-about-link') === id;
          link.classList.toggle('is-active', on);
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }

      var io = null;

      function observe() {
        if (io) io.disconnect();
        if (!('IntersectionObserver' in window)) {
          setActive(panels[0].id);
          return;
        }
        io = new IntersectionObserver(
          function (entries) {
            var visible = entries
              .filter(function (entry) {
                return entry.isIntersecting;
              })
              .sort(function (a, b) {
                return b.intersectionRatio - a.intersectionRatio;
              })[0];
            if (visible && visible.target.id) setActive(visible.target.id);
          },
          { root: scrollRoot(), rootMargin: '-28% 0px -48% 0px', threshold: [0, 0.25, 0.5] }
        );
        Array.prototype.forEach.call(panels, function (panel) {
          io.observe(panel);
        });
      }

      observe();
      if (squeeze.addEventListener) squeeze.addEventListener('change', observe);
      else if (squeeze.addListener) squeeze.addListener(observe);

      Array.prototype.forEach.call(links, function (link) {
        link.addEventListener('click', function () {
          setActive(link.getAttribute('data-about-link'));
        });
      });
    }

    function boot() {
      var nodes = document.querySelectorAll('.kalme-about');
      Array.prototype.forEach.call(nodes, bindAbout);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      var section = event.target.querySelector('.kalme-about') || event.target;
      if (section && section.classList && section.classList.contains('kalme-about')) {
        bindAbout(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalme-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function power4Out(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function makeWord(content) {
      var outer = document.createElement('span');
      outer.className = 'kalme-word';
      var inner = document.createElement('span');
      inner.className = 'kalme-word__in';
      inner.style.transform = 'translate3d(0, 110%, 0)';
      inner.appendChild(content);
      outer.appendChild(inner);
      return outer;
    }

    function wrapHeadingWords(root) {
      if (!root || root.getAttribute('data-words-ready')) return;
      Array.from(root.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          if (!node.textContent || !node.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            frag.appendChild(makeWord(document.createTextNode(part)));
          });
          root.replaceChild(frag, node);
        } else if (node.nodeType === 1) {
          if (node.classList.contains('kalme-heading__accent')) {
            wrapHeadingWords(node);
          } else if (node.classList.contains('kalme-mark')) {
            root.replaceChild(makeWord(node.cloneNode(true)), node);
          }
        }
      });
      root.setAttribute('data-words-ready', '');
    }

    function playWordMask(heading) {
      if (heading.getAttribute('data-words-played')) return;
      heading.setAttribute('data-words-played', '');

      var words = heading.querySelectorAll('.kalme-word__in');
      if (!words.length) return;

      var duration = 1150;
      var stagger = 90;
      var start = performance.now();

      function frame(now) {
        var allDone = true;
        words.forEach(function (word, i) {
          var t = (now - start - i * stagger) / duration;
          if (t < 0) {
            t = 0;
            allDone = false;
          } else if (t < 1) {
            allDone = false;
          } else {
            t = 1;
          }
          var e = power4Out(t);
          word.style.transform = 'translate3d(0,' + ((1 - e) * 110) + '%,0)';
        });
        if (!allDone) requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    }

    function initHeadlineMasks() {
      var headings = document.querySelectorAll('.kalme-promise .kalme-heading, .kalme-duo .kalme-heading');
      if (!headings.length) return;

      headings.forEach(function (heading) {
        wrapHeadingWords(heading);
      });

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        headings.forEach(function (heading) {
          heading.querySelectorAll('.kalme-word__in').forEach(function (word) {
            word.style.transform = 'translate3d(0,0,0)';
          });
        });
        return;
      }

      if (!('IntersectionObserver' in window)) {
        headings.forEach(playWordMask);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            playWordMask(entry.target);
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -12% 0px' }
      );

      headings.forEach(function (heading) {
        io.observe(heading);
      });
    }

    function getJourneyScroller() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        var overflowY = window.getComputedStyle(wrapper).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
          return wrapper;
        }
      }
      return window;
    }

    function initJourney() {
      var root = document.querySelector('[data-kalme-journey]');
      if (!root) return;

      var draw = root.querySelector('.kalme-journey__draw');
      var halo = root.querySelector('.kalme-journey__halo');
      var dot = root.querySelector('.kalme-journey__dot');
      var stationsWrap = root.querySelector('.kalme-journey__stations');
      var steps = root.querySelectorAll('.kalme-journey__step');
      if (!draw || !steps.length) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;

      var length = 0;
      var stations = [];

      function pathLength() {
        try {
          var value = draw.getTotalLength();
          return value && isFinite(value) ? value : 0;
        } catch (err) {
          return 0;
        }
      }

      function layout() {
        length = pathLength();
        if (!length) return;
        draw.style.strokeDasharray = String(length);
        stationsWrap.innerHTML = '';
        stations = [];
        var n = steps.length;
        for (var i = 0; i < n; i++) {
          var t = n === 1 ? 0 : i / (n - 1);
          var pt = draw.getPointAtLength(length * t);
          var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          circle.setAttribute('class', 'kalme-journey__station');
          circle.setAttribute('r', '5');
          circle.setAttribute('cx', String(pt.x));
          circle.setAttribute('cy', String(pt.y));
          stationsWrap.appendChild(circle);
          stations.push(circle);
        }
      }

      function viewportHeight(scroller) {
        if (scroller && scroller !== window && scroller.clientHeight) {
          return scroller.clientHeight;
        }
        return window.innerHeight || document.documentElement.clientHeight || 1;
      }

      function progress() {
        if (!length) return;
        var scroller = getJourneyScroller();
        var rect = root.getBoundingClientRect();
        var range = Math.max(root.offsetHeight - viewportHeight(scroller), 1);
        var p = (-rect.top) / range;
        if (p < 0) p = 0;
        else if (p > 1) p = 1;

        draw.style.strokeDashoffset = String(length * (1 - p));
        var pt = draw.getPointAtLength(length * p);
        halo.setAttribute('cx', String(pt.x));
        halo.setAttribute('cy', String(pt.y));
        dot.setAttribute('cx', String(pt.x));
        dot.setAttribute('cy', String(pt.y));

        var n = steps.length;
        var active = n === 1 ? 0 : Math.round(p * (n - 1));
        steps.forEach(function (step, i) {
          var on = i === active;
          step.classList.toggle('is-on', on);
          if (on) step.setAttribute('aria-current', 'true');
          else step.removeAttribute('aria-current');
        });
        stations.forEach(function (station, i) {
          station.classList.toggle('is-passed', i <= active);
        });
        root.classList.toggle('is-end', active >= n - 1);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          progress();
        });
      }

      function bindScroll() {
        var scroller = getJourneyScroller();
        if (scroller !== window) {
          scroller.addEventListener('scroll', onScroll, { passive: true });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      }

      function ensureLayout(attempt) {
        layout();
        progress();
        if (length || attempt > 8) return;
        setTimeout(function () {
          ensureLayout(attempt + 1);
        }, 80);
      }

      ensureLayout(0);
      bindScroll();
      window.addEventListener('resize', function () {
        layout();
        progress();
      });
    }

    function initAgesCarousel() {
      var root = document.querySelector('[data-kalme-ages]');
      if (!root) return;
      var track = root.querySelector('[data-ages-track]');
      var prev = root.querySelector('[data-ages-prev]');
      var next = root.querySelector('[data-ages-next]');
      if (!track || !prev || !next) return;

      function cardStep() {
        var card = track.querySelector('.kalme-ages__card');
        if (!card) return 280;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 18;
        return card.getBoundingClientRect().width + gap;
      }

      function updateNav() {
        var max = track.scrollWidth - track.clientWidth - 4;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max;
      }

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduce ? 'auto' : 'smooth';

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: behavior });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: behavior });
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    function initPromiseMotion() {
      var sections = document.querySelectorAll('[data-kalme-reveal], [data-kalme-promise]');
      if (!sections.length) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        sections.forEach(function (section) {
          section.classList.add('is-in');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.28, rootMargin: '0px 0px -10% 0px' }
      );

      sections.forEach(function (section) {
        section.classList.add('is-ready');
        io.observe(section);
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.kalme-promise__video').forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
      });
    }

    function init() {
    const root = document.querySelector('[data-kalme-guide]');
    if (!root) return;

    const i18nEl = document.getElementById('kalme-guide-i18n');
    const i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
    const form = root.querySelector('[data-guide-form]');
    const nextBtn = root.querySelector('[data-guide-next]');
    const ctaBtn = root.querySelector('[data-guide-cta]');
    const summary = root.querySelector('[data-guide-summary]');
    const stepLabel = root.querySelector('[data-guide-step-label]');
    const bar = root.querySelector('[data-guide-bar]');
    const fill = root.querySelector('.kalme-guide__fill');
    const sticky = document.querySelector('[data-guide-sticky]');
    const stickySummary = sticky && sticky.querySelector('[data-guide-sticky-summary]');
    const stickyCta = sticky && sticky.querySelector('[data-guide-sticky-cta]');
    const productUrl = root.getAttribute('data-guide-product') || '/collections/all';
    const catalogUrl = root.getAttribute('data-guide-catalog') || '/collections/all';
    const catalogEl = document.getElementById('kalme-guide-catalog');
    let catalog = [];
    try {
      catalog = catalogEl ? JSON.parse(catalogEl.textContent) : [];
    } catch (err) {
      catalog = [];
    }
    if (!Array.isArray(catalog)) catalog = [];

    const ageLabel = {
      '0-2': i18n.age_0_2 || '0–2',
      '2-3': i18n.age_2_3 || '2–3',
      '3-5': i18n.age_3_5 || '3–5',
      '5-7': i18n.age_3_5 || '3–5'
    };
    const interestLabel = {
      manipuler: i18n.interest_manipuler_word || 'hands-on',
      reflechir: i18n.interest_reflechir_word || 'think',
      creer: i18n.interest_creer_word || 'create',
      ensemble: i18n.interest_ensemble_word || 'play together'
    };

    let step = 1;
    const answers = { age: '', interest: '' };

    /* Quiz âge × intérêt → un produit. Pas de sélection 5–7 ans : on retombe sur 3–5.
       0-2 manipuler livre tissu | 0-2 ensemble chariot de marche | 0-2 reflechir panneau dauphin | 0-2 creer tour
       2-3 manipuler coffret 4 boîtes | 2-3 reflechir planche | 2-3 creer/ensemble tour
       3-5 manipuler labyrinthe | 3-5 reflechir puzzle | 3-5 creer ville | 3-5 ensemble mini cuisine
       5-7 : aucun produit dédié, repli sur l’âge voisin 3–5. */
    const PROFILES = {
      'livre-tissu-animaux-ferme': { ages: ['0-2'], interests: ['manipuler', 'ensemble'] },
      'chariot-de-marche-cuisine': { ages: ['0-2'], interests: ['bouger', 'ensemble', 'manipuler'] },
      'tour-apprentissage-montessori-3-en-1': { ages: ['0-2', '2-3', '3-5'], interests: ['ensemble', 'creer'] },
      'panneau-activites-mural-dauphin': { ages: ['0-2', '2-3'], interests: ['manipuler'] },
      'planche-activites-bois': { ages: ['0-2', '2-3', '3-5'], interests: ['manipuler'] },
      'coffret-boites-activites-montessori': { ages: ['0-2', '2-3'], interests: ['manipuler', 'reflechir'] },
      'labyrinthe-magnetique-tri-couleurs': { ages: ['3-5'], interests: ['manipuler', 'reflechir'] },
      'puzzle-systeme-solaire': { ages: ['3-5'], interests: ['reflechir', 'communiquer'] },
      'puzzles-systeme-solaire': { ages: ['3-5'], interests: ['reflechir'] },
      'coffret-ville-bois-115': { ages: ['3-5'], interests: ['creer', 'ensemble'] },
      'mini-etabli-bois': { ages: ['3-5'], interests: ['creer', 'manipuler'] },
      'mini-cuisine-renard': { ages: ['3-5'], interests: ['ensemble', 'creer'] },
      'chariot-de-menage-bois': { ages: ['3-5'], interests: ['ensemble', 'manipuler'] }
    };
    const AGE_NEAR = {
      '0-2': ['2-3'],
      '2-3': ['0-2', '3-5'],
      '3-5': ['2-3', '5-7'],
      '5-7': ['3-5']
    };
    const WHY = {
      manipuler: i18n.rec_why_manipuler,
      reflechir: i18n.rec_why_reflechir,
      creer: i18n.rec_why_creer,
      ensemble: i18n.rec_why_ensemble
    };

    function priceValue(product) {
      const raw = String((product && product.price) || '')
        .replace(/[^\d.,]/g, '')
        .replace(',', '.');
      const n = parseFloat(raw);
      return isNaN(n) ? 999 : n;
    }

    function uniq(list) {
      const seen = {};
      const out = [];
      for (let i = 0; i < list.length; i++) {
        if (!list[i] || seen[list[i]]) continue;
        seen[list[i]] = true;
        out.push(list[i]);
      }
      return out;
    }

    function inferProfile(product) {
      const tags = (product.tags || []).map(function (tag) {
        return String(tag).toLowerCase();
      });
      function has(needle) {
        return tags.some(function (tag) {
          return tag.indexOf(needle) !== -1;
        });
      }
      const ages = [];
      const interests = [];
      if (has('bebe') || has('0-2') || has('18-mois') || has('dentition')) ages.push('0-2');
      if (has('2-3') || has('18-mois')) ages.push('2-3');
      if (has('3-ans') || has('3-6') || has('3-5') || has('4-6')) {
        ages.push('3-5');
        ages.push('5-7');
      }
      if (has('5-7') || has('6-ans')) ages.push('5-7');
      if (has('motricite') || has('busy') || has('sensoriel') || has('planche') || has('permanence')) {
        interests.push('manipuler');
      }
      if (has('puzzle') || has('educatif') || has('couleurs') || has('formes')) interests.push('reflechir');
      if (has('construction') || has('ville') || has('etabli') || has('bricolage')) interests.push('creer');
      if (has('imitation') || has('cuisine') || has('dinette') || has('menage') || has('tour-apprentissage')) {
        interests.push('ensemble');
      }
      return {
        ages: uniq(ages.length ? ages : ['2-3', '3-5']),
        interests: uniq(interests.length ? interests : ['manipuler'])
      };
    }

    function profileFor(product) {
      return PROFILES[product.handle] || inferProfile(product);
    }

    function scoreProduct(product, age, interest) {
      const profile = profileFor(product);
      if (profile.ages.indexOf(age) === -1) return -1;
      let score = 10;
      if (profile.ages.length === 1) score += 5;
      const ix = profile.interests.indexOf(interest);
      if (ix === -1) score += 1;
      else {
        score += 8;
        if (ix === 0) score += 4;
      }
      return score;
    }

    function rankFor(age, interest) {
      const scored = catalog
        .map(function (product) {
          return { product: product, score: scoreProduct(product, age, interest) };
        })
        .filter(function (row) {
          return row.score >= 0;
        });
      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return priceValue(a.product) - priceValue(b.product);
      });
      return scored;
    }

    function rankedProducts(age, interest) {
      let scored = rankFor(age, interest);
      if (!scored.length) {
        const nearby = AGE_NEAR[age] || [];
        for (let i = 0; i < nearby.length && !scored.length; i++) {
          scored = rankFor(nearby[i], interest);
        }
      }
      return scored.map(function (row) {
        return row.product;
      });
    }

    function fallbackRec(echo) {
      return {
        echo: echo,
        title: i18n.rec_fallback_title,
        text: i18n.rec_fallback_text,
        href: catalogUrl || productUrl,
        cta: i18n.cta_ages,
        image: '',
        alt: '',
        price: '',
        also: []
      };
    }

    function recommend() {
      const age = answers.age;
      const interest = answers.interest;
      const echo = (i18n.echo || 'For a child aged __age__ who likes to __interest__.')
        .replace('__age__', ageLabel[age] || '')
        .replace('__interest__', interestLabel[interest] || '');

      const ranked = rankedProducts(age, interest);
      const pick = ranked[0];
      if (!pick) return fallbackRec(echo);

      return {
        echo: echo,
        title: pick.title,
        text: WHY[interest] || i18n.rec_fallback_text,
        href: pick.url || productUrl,
        cta: i18n.cta_toy,
        image: pick.image || '',
        alt: pick.alt || pick.title,
        price: pick.price || '',
        also: ranked.slice(1, 3)
      };
    }

    function renderAlso(items) {
      const wrap = root.querySelector('[data-guide-also]');
      const list = root.querySelector('[data-guide-also-list]');
      if (!wrap || !list) return;
      list.textContent = '';
      if (!items || !items.length) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      items.forEach(function (item) {
        const link = document.createElement('a');
        link.className = 'kalme-guide__also-item';
        link.href = item.url || catalogUrl;
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.alt || item.title || '';
          img.width = 72;
          img.height = 72;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        const name = document.createElement('span');
        name.textContent = item.title || '';
        link.appendChild(name);
        list.appendChild(link);
      });
    }

    function summaryText() {
      if (step === 1) return answers.age ? ageLabel[answers.age] : (i18n.start || '');
      if (step === 2) {
        if (answers.interest) return ageLabel[answers.age] + ' · ' + interestLabel[answers.interest];
        return ageLabel[answers.age] + ' · ' + (i18n.next_interest || '');
      }
      const rec = recommend();
      return rec.echo;
    }

    function render() {
      root.querySelectorAll('[data-guide-panel]').forEach(function (panel) {
        const on = Number(panel.getAttribute('data-guide-panel')) === step;
        panel.hidden = !on;
        panel.classList.toggle('is-on', on);
      });

      if (stepLabel) {
        stepLabel.textContent = (i18n.step_of || 'Step __current__ of 3').replace('__current__', String(step));
      }
      bar.setAttribute('aria-valuenow', String(step));
      fill.style.transform = 'scaleX(' + (step / 3) + ')';
      summary.textContent = summaryText();

      const ready = (step === 1 && answers.age) || (step === 2 && answers.interest) || step === 3;
      nextBtn.disabled = !ready || step === 3;
      nextBtn.hidden = step === 3;
      ctaBtn.hidden = step !== 3;

      if (step === 3) {
        const rec = recommend();
        const pick = root.querySelector('[data-guide-pick]');
        const pickImg = root.querySelector('[data-guide-pick-img]');
        const pickPrice = root.querySelector('[data-guide-pick-price]');
        root.querySelector('[data-guide-echo]').textContent = rec.echo;
        root.querySelector('[data-guide-result-title]').textContent = rec.title;
        root.querySelector('[data-guide-result-text]').textContent = rec.text;
        if (pick) pick.href = rec.href;
        if (pickImg) {
          if (rec.image) {
            pickImg.src = rec.image;
            pickImg.alt = rec.alt || rec.title || '';
            pickImg.hidden = false;
          } else {
            pickImg.removeAttribute('src');
            pickImg.alt = '';
            pickImg.hidden = true;
          }
        }
        if (pickPrice) {
          pickPrice.textContent = rec.price || '';
          pickPrice.hidden = !rec.price;
        }
        renderAlso(rec.also);
        ctaBtn.href = rec.href;
        ctaBtn.textContent = rec.cta;
        if (stickyCta) {
          stickyCta.href = rec.href;
          stickyCta.textContent = rec.cta;
        }
      } else if (stickyCta) {
        stickyCta.href = '#guide';
        stickyCta.textContent = i18n.resume || '';
      }

      if (stickySummary) stickySummary.textContent = summaryText();
      updateSticky();
    }

    function updateSticky() {
      if (!sticky) return;
      const started = Boolean(answers.age);
      const rect = root.getBoundingClientRect();
      const off = rect.bottom < 80 || rect.top > window.innerHeight - 40;
      const show = started && off;
      sticky.hidden = !show;
      sticky.classList.toggle('is-on', show);
    }

    form.addEventListener('change', function (event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      answers[input.name] = input.value;
      input.closest('.kalme-guide__choice') &&
        root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (el) {
          el.closest('.kalme-guide__choice').classList.toggle('is-picked', el.checked);
        });
      render();
    });

    nextBtn.addEventListener('click', function () {
      if (step === 1 && !answers.age) return;
      if (step === 2 && !answers.interest) return;
      if (step < 3) step += 1;
      render();
      const panel = root.querySelector('[data-guide-panel="' + step + '"] legend');
      if (panel) panel.focus({ preventScroll: true });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    render();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHeadlineMasks();
        initPromiseMotion();
        initJourney();
        initAgesCarousel();
        init();
      });
    } else {
      initHeadlineMasks();
      initPromiseMotion();
      initJourney();
      initAgesCarousel();
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalme-lp-scrolly"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kalme-ways]');
    if (!root) return;
    var track = root.querySelector('[data-ways-track]');
    var prev = root.querySelector('[data-ways-prev]');
    var next = root.querySelector('[data-ways-next]');
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.kalme-scrolly__card');
      if (!card) return 280;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 18;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max;
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduce ? 'auto' : 'smooth';

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: behavior });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: behavior });
    });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
